import { useSelector } from "react-redux";
import printJS from 'print-js'

export const PrintDocs = () => {
  const printQueue = useSelector(
    (state: any) => state.listingReducer.printQueue
  );
  const onPrint = () => {
    for (let i = 0; i < printQueue.length; i++) {
      printJS(printQueue[i])
    }
  };

  if (printQueue.length === 0) {
    return null;
  }

  return (
    <div>
      <button
        onClick={onPrint}
        className="bg-primary text-white px-4 py-3 text-s font-semibold flex gap-x-1"
      >
        Print
      </button>
    </div>
  );
};
